import { render, staticRenderFns } from "./MediaLogin.vue?vue&type=template&id=a5220972&scoped=true"
import script from "./MediaLogin.vue?vue&type=script&lang=js"
export * from "./MediaLogin.vue?vue&type=script&lang=js"
import style0 from "./MediaLogin.vue?vue&type=style&index=0&id=a5220972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5220972",
  null
  
)

export default component.exports